import FallbackImage from "../static/img/fallback.png";

export default function Img(props) {
    const onError = (e) => {
        e.target.src = FallbackImage;
    }

    return <img alt={""} onResize={console.log} onError={onError} {...props} />
}